export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";